//eslint-disable
import React from 'react';
import { Link } from "react-router-dom";
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaComponent } from './ArcaComponent';

export class Pets extends ArcaComponent {
    static displayName = Pets.name;

    constructor(props) {
        super(props);

        this.state = { pets: [], loading: true };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.getPetData();
    }

    handleClick(e) {
    }

    renderListOfPets(pets) {
        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Owner</th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pets.map(pet =>
                            <tr key={pet.id}>
                                <td>{pet.fullName}</td>
                                <td>{pet.code}</td>
                                <td>{pet.ownerName}</td>
                                <td>
                                    <Link to={"/personView?id=" + pet.ownerId}>Person</Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderListOfPets(this.state.pets);

        return (
            <div>
                <h1 id="tabelLabel" >Pets</h1>
                <p>The pets registered in the system.</p>
                {contents}
            </div>
        );
    }

    async getPetData() {
        const response = await fetch('pet', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ArcaSecurity.Token}`
            }
        });

        const data = await response.json();
        this.setState({ pets: data, loading: false });
    }
}
